const dbBodyStyles = [
    { key: 'originalThenTranslated', value: 'Original followed by Translated' },
    { key: 'translatedThenOriginal', value: 'Translated followed by Original' },
];
export default dbBodyStyles;